module.exports = __webpack_public_path__ + "media/images/social/linkedin-3758cc14a3169107672300bded3eaa5e.png";